import { render, staticRenderFns } from "./RepriseAdd.vue?vue&type=template&id=6961f808&"
import script from "./RepriseAdd.vue?vue&type=script&lang=js&"
export * from "./RepriseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports